<template>
  <b-field
    :label="label"
    :type="hasError() ? 'is-danger' : ''"
    :message="errorMessage()"
    :class="{ required: required }"
  >
    <template
      v-if="hasInfo || isHtmlLabel"
      #label
    >
      <span
        v-if="isHtmlLabel"
        v-html="label"
      />
      <span v-else>
        {{ label }}
        <span>
          <b-tooltip
            type="is-light"
            :size="infoSize"
            :position="infoPosition"
            multilined
          >
            <i :class="infoIcon" />
            <template #content>
              <p v-if="infoType == 'text'">{{ info }}</p>
              <slot
                v-if="infoType == 'html'"
                name="info"
              >
                <div v-html="info" />
              </slot>
            </template>
          </b-tooltip>
        </span>
      </span>
    </template>
    <b-datepicker
      :position="position"
      :value="date"
      :disabled="disabled"
      :append-to-body="true"
      :locale="$laravel.app.locale"
      :placeholder="$t('click_or_select_date')"
      icon="calendar-today"
      :class="{ 'is-danger': hasError() }"
      @input="onInput"
    />
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator: (prop) => typeof prop === "string" || prop === null,
    },
    position: {
      type: String,
      default: "is-top-right",
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasInfo: {
      default: false,
      type: Boolean,
    },
    infoIcon: {
      default: "mdi mdi-help-circle-outline",
      type: String,
    },
    info: {
      default: "",
      type: String,
    },
    infoPosition: {
      default: "is-top",
      type: String,
    },
    infoSize: {
      default: "is-medium",
      type: String,
    },
    infoType: {
      default: "text",
      type: String,
    },
    isHtmlLabel: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      date: null,
    };
  },
  watch: {
    value: {
      handler(newValues, oldValues) {
        this.date = this.stringToDate(this.value);
        if (this.date != this.value) {
          this.inputListener(this.dateToString(this.date));
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onInput(payload) {
      this.inputListener(this.dateToString(payload));
    },
    dateToString(date) {
      if (date == "" || date == null) {
        return null;
      }

      return this.$dayjs(date).format("YYYY-MM-DD");
    },
    stringToDate(date) {

      if (date == "" || date == null) {
        return null;
      }

      // If date is 2021-01-01T00:00:00Z, it will convert to 2021-01-01 (beginning of day) in the local timezone
      // instead of 2021-01-01 (beginning of day) in UTC, which could be a day earlier or a day later in the local timezone
      if (date.includes("T00:00:00")) {
        date = date.split("T")[0];
      }

      return this.$dayjs(date).toDate();
    },
  },
};
</script>
